import { Pipe, PipeTransform } from '@angular/core';
import { convertToHumanReadable } from 'app/trello/utility/duration-formatter';

@Pipe({
  name: 'readableSeconds',
  pure: true,
})
export class ReadableSecondsPipe implements PipeTransform {

  transform(
    value: number | null | undefined,
    maxUnits: number = 1,
  ): string {

    if (value === null || value === undefined) {
      return '';
    }

    const scaledValue = {seconds: value};

    return convertToHumanReadable(scaledValue, maxUnits);
  }

}
